module.exports = __webpack_public_path__ + "static/img/COC2021-31.8395927.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-31.jpg
// module id = yl70
// module chunks = 0